import React from "react";
import ReactDOM from "react-dom/client";
import { createBrowserRouter, RouterProvider, Navigate } from "react-router-dom";
import "./index.css";
import reportWebVitals from "./reportWebVitals";
import { RESORTS } from "./data";
import Guide from "./routes/guide";

const getDefaultResort = (): string => {
  const last = localStorage.getItem("lastResort");
  if (last && RESORTS[last]) return last;
  return "disneyland";
};

const router = createBrowserRouter([
  {
    path: "/",
    element: <Navigate to={`/guide/${getDefaultResort()}`} replace />,
  },
  {
    path: "/guide/:resortKey",
    element: <Guide />,
  },
]);

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement,
);
root.render(
  <React.StrictMode>
    <RouterProvider router={router} />
  </React.StrictMode>,
);

reportWebVitals();
